module.exports = __webpack_public_path__ + "img/B3-2.40211c2b.jpg";